<!-- Title -->
<div class="text-center" *ngIf="!courseComplete">
  <h1>Post-evaluation</h1>
</div>

<!-- Post-Evaluation Survey Content -->
<div id="post-evaluation-survey" *ngIf="!courseComplete">

  <div class="container content-box module-content">
    <p>Now that you have finished the RentWise educational program, we would like to know more about what
      information you found most helpful and what you may have learned. This information will help us adjust
      the sessions to meet renters’ needs. By completing this form, you are agreeing that we can use the
      information to summarize the program. We will not use your name or any information you provide in any
      way that might identify you. Your identity will remain confidential.</p>

    <!-- Form -->
    <form name="form" (submit)="f.form.valid && submitForm()" #f="ngForm" novalidate>

      <!-- Question 1 -->
      <section *ngIf="question1 as q" class="question1">
        <p>1. <span [innerHtml]="q.questionWithHints || q.question"></span></p>

        <table class="table table-bordered table-striped" *ngIf="q.answer as table">
          <thead>
            <tr>
              <th scope="col" class="th-question">I know...</th>
              <th scope="col" class="th-answer rotated-cell"><span>Know Nothing<br>About Topic</span></th>
              <th scope="col" class="th-answer rotated-cell"><span>Know Very Little<br>About Topic</span></th>
              <th scope="col" class="th-answer rotated-cell"><span>Know Some Things<br>About Topic</span></th>
              <th scope="col" class="th-answer rotated-cell"><span>Know a Lot<br>About Topic</span></th>
              <th scope="col" class="th-comments rotated-cell"><span>Any comments?</span></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let question of table.questions; let qindex=index">
              <tr>
                <td class="td-question" scope="row">{{letter(qindex)}}. {{question}}</td>

                <td class="td-answer text-center" (keypress)="table_radioGroup_keypress(q.answer, qindex, $event)"
                    *ngFor="let option of table.options; let oindex=index">
                  <div class="form-group radio-group" [class.has-error]="f.submitted && radio.invalid">
                    <input type="radio" class="btn-check" name="table{{q.questionNumber}}_options{{qindex}}" id="table{{q.questionNumber}}_options{{qindex}}_{{oindex}}" autocomplete="off"
                      [(ngModel)]="table.answers[qindex]" #radio="ngModel" [value]="option" required>
                    <label class="custom btn" for="table{{q.questionNumber}}_options{{qindex}}_{{oindex}}"
                      [ngClass]="[table.answers[qindex] === option ? 'btn-secondary' : 'btn-outline-secondary']"
                      (click)="table_radio_click(q.answer, option, qindex, $event)">{{option}}</label>
                  </div>
                </td>

                <td class="td-comments">
                  <button type="button" class="custom btn add-comment" (click)="table_toggleComment(q, qindex)"
                      [matTooltip]="ui.comment(table.comments[qindex]).show !== true ? 'Add comments' : 'Remove comments'" [matTooltipShowDelay]="1000">
                    <mdb-icon far icon="comment-alt" class="icon-comment" size="lg"></mdb-icon>
                    <mdb-icon fas icon="plus" class="icon-plus" size="xs" *ngIf="ui.comment(table.comments[qindex]).show !== true"></mdb-icon>
                    <mdb-icon fas icon="minus" class="icon-minus" size="xs" *ngIf="ui.comment(table.comments[qindex]).show === true"></mdb-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="ui.comment(table.comments[qindex]).show">
                <td colspan="6">
                  <textarea class="form-control comments" name="comments" rows="2" placeholder="Enter comments..."
                    [(ngModel)]="ui.comment(table.comments[qindex]).text" [ngModelOptions]="{ standalone: true }">
                  </textarea>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </section>

      <!-- Question 2 -->
      <section *ngIf="question2 as q" class="question2">
        <p>2. <span [innerHtml]="q.questionWithHints || q.question"></span></p>

        <table class="table table-bordered table-striped" *ngIf="q.answer as table">
          <thead>
            <tr>
              <th scope="col" class="th-question">My experiences as a renter</th>
              <th scope="col" class="th-answer rotated-cell"><span>Strongly<br>Disagree</span></th>
              <th scope="col" class="th-answer rotated-cell"><span>Disagree</span></th>
              <th scope="col" class="th-answer rotated-cell"><span>Agree</span></th>
              <th scope="col" class="th-answer rotated-cell"><span>Strongly<br>Agree</span></th>
              <th scope="col" class="th-comments rotated-cell"><span>Any comments</span></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let question of table.questions; let qindex=index">
              <tr *ngIf="letter(qindex) === 'j'">
                <td colspan="6">
                  <strong>Answer <u>j. to n. only if you have moved</u> since starting RentWise. Please <u>do</u> answer O*</strong>
                </td>
              </tr>

              <tr>
                <td class="td-question" scope="row">{{letter(qindex)}}.{{letter(qindex) === 'o' ? '*' : ''}} {{question}}</td>

                <td class="td-answer text-center" (keypress)="table_radioGroup_keypress(q.answer, qindex, $event)"
                    *ngFor="let option of table.options; let oindex=index">
                  <div class="form-group radio-group" [class.has-error]="f.submitted && radio.invalid">
                    <input type="radio" class="btn-check" name="table{{q.questionNumber}}_options{{qindex}}" id="table{{q.questionNumber}}_options{{qindex}}_{{oindex}}" autocomplete="off"
                      [(ngModel)]="table.answers[qindex]" #radio="ngModel" [value]="option" [required]="false === ['j', 'k', 'l', 'm', 'n'].includes(letter(qindex))">
                    <label class="custom btn" for="table{{q.questionNumber}}_options{{qindex}}_{{oindex}}"
                      [ngClass]="[table.answers[qindex] === option ? 'btn-secondary' : 'btn-outline-secondary']"
                      (click)="table_radio_click(q.answer, option, qindex, $event)">{{option}}</label>
                  </div>
                </td>

                <td class="td-comments">
                  <button type="button" class="custom btn add-comment" (click)="table_toggleComment(q, qindex)"
                      [matTooltip]="ui.comment(table.comments[qindex]).show !== true ? 'Add comments' : 'Remove comments'" [matTooltipShowDelay]="1000">
                    <mdb-icon far icon="comment-alt" class="icon-comment" size="lg"></mdb-icon>
                    <mdb-icon fas icon="plus" class="icon-plus" size="xs" *ngIf="ui.comment(table.comments[qindex]).show !== true"></mdb-icon>
                    <mdb-icon fas icon="minus" class="icon-minus" size="xs" *ngIf="ui.comment(table.comments[qindex]).show === true"></mdb-icon>
                  </button>
                </td>
              </tr>

              <tr *ngIf="ui.comment(table.comments[qindex]).show">
                <td colspan="6">
                  <textarea class="form-control comments" name="comments" rows="2" placeholder="Enter comments..."
                    [(ngModel)]="ui.comment(table.comments[qindex]).text" [ngModelOptions]="{ standalone: true }">
                  </textarea>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </section>

      <!-- Question 3 -->
      <section *ngIf="question3 as q" class="question3">
        <p>3. <span [innerHtml]="q.questionWithHints || q.question"></span></p>
        <textarea class="form-control" name="answer3" rows="4" [(ngModel)]="q.answer.text" [ngModelOptions]="{ standalone: true }"></textarea>
      </section>

      <!-- Question 4 -->
      <section *ngIf="question4 as q" class="question4">
        <p>4. <span [innerHtml]="q.questionWithHints || q.question"></span></p>
        <textarea class="form-control" name="answer4" rows="4" [(ngModel)]="q.answer.text" [ngModelOptions]="{ standalone: true }"></textarea>
      </section>

      <!-- Question 5 -->
      <section *ngIf="question5 as q" class="question5">
        <p>5. <span [innerHtml]="q.questionWithHints || q.question"></span></p>
        <textarea class="form-control" name="answer5" rows="4" [(ngModel)]="q.answer.text" [ngModelOptions]="{ standalone: true }"></textarea>
      </section>

      <!-- Question 6 -->
      <section *ngIf="question6 as q" class="question6">
        <p>6. <span [innerHtml]="q.questionWithHints || q.question"></span></p>
        <textarea class="form-control" name="answer6" rows="4" [(ngModel)]="q.answer.text" [ngModelOptions]="{ standalone: true }"></textarea>
      </section>

      <!-- Form Errors -->
      <div *ngIf="f.submitted && f.invalid" class="form-invalid">
        Please fix above errors highlighted in red and then submit the form.
      </div>

      <!-- Submit Form -->
      <button type="submit" class="btn waves-dark">Submit <i class="fas fa-angle-right ml-3"></i></button>
    </form>
  </div>
</div>

<!-- Course Complete -->
<section *ngIf="courseComplete">

  <!-- Message -->
  <div class="text-center">
      <h1 style="margin-bottom: 20px;">Congratulations! You've completed RentWise.</h1>
      <h4 style="margin-bottom: 60px;">Click 'Get Certificate' to receive your personalized certificate.</h4>

      <!-- Navigation Buttons -->
      <div class="certificate-btns">
          <button type="button" class="btn waves-dark w-25" [routerLink]="'/courses/RentWise'"><i class="fas fa-angle-left mr-3"></i>Back</button>
          <button type="button" class="btn waves-dark w-25" [routerLink]="'/courses/RentWise/certificate'">Get Certificate<i class="fas fa-angle-right ml-3"></i></button>
      </div>
  </div>
</section>
